import React, { useMemo } from 'react'
import { useLoaderData } from 'react-router-dom'
import LoadPageComponents from './LoadPageComponents'
const HomePage = props => {
  const pageArray = useLoaderData()[0]

  const reactPageData = useMemo(() => pageArray?.acf, [pageArray])

  const pages = useMemo(
    () =>
      reactPageData &&
      Object?.keys(reactPageData)
        ?.filter((key, index) => reactPageData[key]?.page_order && key)
        ?.sort((a, b) =>
          reactPageData[a]?.page_order > reactPageData[b]?.page_order
            ? 1
            : reactPageData[a]?.page_order < reactPageData[b]?.page_order
            ? -1
            : 0
        ),
    [reactPageData]
  )
  return (
    // <div className='page-container'>
    <div className='page-container'>
      {pages &&
        pages?.map((page, index) => (
          <LoadPageComponents
            key={index}
            page={page}
            data={{ ...reactPageData[page] }}
          />
        ))}
    </div>
  )
}
export default HomePage
